<template>
  <div class="sky-hc-footer">
    <div class="sky-hc-footer__left">
      <div class="sky-hc-footer__nav">
        <div class="sky-hc-footer__nav-tit">{{ $t('help.picTxt') }}</div>
        <div class="sky-hc-footer__nav-txt" v-for="(item, index) in picTxtArr" :key="index" @click="handleGotoInnerPage(item)">{{item.name}}</div>
      </div>
      <div class="sky-hc-footer__nav">
        <div class="sky-hc-footer__nav-tit">{{$t('help.vedio')}}</div>
        <div class="sky-hc-footer__nav-txt" v-for="(item,index) in vedioArr" :key="'0' + index" @click="handleGotoInnerPage(item)">{{item.name}}</div>
      </div>
      <div class="sky-hc-footer__nav">
        <div class="sky-hc-footer__nav-tit">{{$t('help.more')}}</div>
        <div class="sky-hc-footer__nav-txt" v-for="(item,index) in otherArr" :key="'00'+index" @click="handleGotoInnerPage(item)">{{item.name}}</div>
        <div class="sky-hc-footer__nav-txt" @click="handleGotoFeedback">{{ $t('help.feedback') }}</div>
        <div class="sky-hc-footer__nav-txt" @click="handleGoToInnerPage">{{ $t('help.downCenter') }}</div>
        <div class="sky-hc-footer__nav-txt" @click="handleGotoExperience">{{ $t('help.productExperience') }}</div>
      </div>
    </div>
    <div class="sky-hc-footer__right">
      <div class="sky-hc-footer__qr-code">
        <div class="sky-hc-footer__qr-code-img-box">
          <img class="sky-hc-footer__qr-code-img" src="@/assets/images/help/code_officail_account.png" />
        </div>
        <div class="sky-hc-footer__qr-code-txt">{{ $t('help.rjOfficailAccountCode') }}</div>
      </div>
      <div class="sky-hc-footer__qr-code">
        <div class="sky-hc-footer__qr-code-img-box sky-hc-footer__qr-code-img-box--micro">
          <img class="sky-hc-footer__qr-code-img" src="@/assets/images/help/code_micro.png" />
        </div>
        <div class="sky-hc-footer__qr-code-txt">{{ $t('help.rjRclMicroCode') }}</div>
      </div>
    </div>
    <dialog-experience-account :isVisible="isVisible" @close="handleCloseExperience"></dialog-experience-account>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import DialogExperienceAccount from './DialogExperienceAccount'

import { getBootomInfo, getCategory } from '@/api/help'
import { CATEGORY_TYPE , CONTACT_URL } from '@/utils/enum'

export default {
  name: 'commonFooter',
  components: {
    DialogExperienceAccount
  },
  computed: {
    ...mapGetters(['downloadId'])
  },
  data() {
    return {
      firstCategory: {},
      secondCategory: {},
      picTxtArr: [],
      vedioArr: [],
      otherArr: [],
      isVisible: false
    }
  },
  created() {
    this.handleGetBottomInfo()
  },
  methods: {
    handleGotoFeedback() {
      window.open(CONTACT_URL.FEEDBACK_URL, 'help')
    },
    handleGotoExperience() {
      this.isVisible = true
    },

    handleCloseExperience() {
      this.isVisible = false
    },
    handleGoToInnerPage() {
      if (!this.downloadId) {
        return
      }
      this.$router.push({
        path: `/help/content?categoryId=${this.downloadId}&categoryName=${this.$t('help.downCenter')}&type=${
          CATEGORY_TYPE.FILE
        }&tab=0`
      })
    },
    /* 
      获取底部内容
     */
    handleGetBottomInfo() {
      getBootomInfo().then(response => {
        const content = response.data.content
        this.firstCategory = content.first
        this.secondCategory = content.second
        this.otherArr = content.others
        if (this.otherArr && this.otherArr.length) {
          this.otherArr = this.otherArr.splice(0,3)
        }
        if (this.firstCategory && this.firstCategory.id) {
          getCategory({
            id: this.firstCategory.id
          }).then(res => {
            this.picTxtArr = res.data.content.children
            if (this.picTxtArr && this.picTxtArr.length) {
              this.picTxtArr = this.picTxtArr.splice(0,6)
            }
          })
        }
        if (this.secondCategory && this.secondCategory.id) {
          getCategory({
            id: this.secondCategory.id
          }).then(res => {
            this.vedioArr = res.data.content.children
            if (this.vedioArr && this.vedioArr.length) {
              this.vedioArr = this.vedioArr.splice(0,6)
            }
          })
        }
      })
    },
    handleGotoInnerPage(item) {
      this.$router.push({
          path: `/help/content?categoryId=${item.id}&categoryName=${item.name}&type=${CATEGORY_TYPE.ARTICLE}`
        })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-footer){
  width: 100%;
  height: 337px;
  background: #2A2A32;
  display: flex;
  padding: 0 360px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  @include e(left){
    display: flex;
  }
  @include e(nav){
    width: 226px;
    padding-right: 10px;
    padding-top: 60px;
    box-sizing: border-box;
  }
  @include e(nav-tit){
    font-size: $--font-size-big;
    color: #FFFFFF;
    line-height: 26px;
    margin-bottom: 20px;
  }
  @include e(nav-txt) {
    font-size: $--size-base;
    line-height: 19px;
    color: rgba(255, 255, 255, 0.72);
    margin-bottom: 19px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  @include e(right){
    display: flex;
  }
  @include e(qr-code-img-box){
    width: 160px;
    height: 160px;
    border-radius: 6px;
    overflow: hidden;
    @include m(micro){
      padding: 10px;
      background: #fff;
    }
  }
  @include e(qr-code-img){
    width: 100%;
    height: 100%;
  }
  @include e(qr-code-txt){
    color: rgba(255, 255, 255, 0.72);
    line-height: 19px;
    font-size: $--size-base;
    margin-top: 20px;
    text-align: center;
  }
  @include e(qr-code){
    padding-top: 60px;
    &:nth-child(1){
      margin-right: 80px;
    }
  }
}


</style>